import { FC } from 'react'
import { Button, Tooltip, App } from 'antd'
import { useRecalcAllFromExcelMutation } from '../../../../store/api/calculation-positions-api'

interface RecalcCalculationsFromExcelProps {}

const RecalcCalculationsFromExcel: FC<RecalcCalculationsFromExcelProps> = () => {
    const { notification } = App.useApp()
    const [recalcAllFromExcel, { isLoading }] = useRecalcAllFromExcelMutation()

    const handleRecalc = async () => {
        try {
            const result = await recalcAllFromExcel().unwrap()

            const data = (result as any)?.data || result
            const updated = data?.updated ?? 0
            const errors = data?.errors ?? 0

            notification.success({
                message: 'Пересчет завершён',
                description: `Обновлено позиций: ${updated}${errors > 0 ? `. Ошибок: ${errors}` : ''}`,
                placement: 'bottomRight',
                duration: 5,
            })
        } catch (err: any) {
            console.error('Полная ошибка при пересчете:', err)

            let errorMessage = 'Произошла ошибка при пересчете'
            let errorTitle = 'Ошибка при пересчете'

            const status = err?.originalStatus || err?.status

            if (status === 405) {
                errorTitle = 'Метод не разрешен (405)'
                errorMessage = 'Endpoint не поддерживает POST метод. Проверьте настройки бэкенда: /api/calculation-positions/recalc-all-from-excel должен принимать POST запросы.'
            } else if (status === 404) {
                errorTitle = 'Endpoint не найден (404)'
                errorMessage = 'Endpoint /api/calculation-positions/recalc-all-from-excel не найден на сервере. Убедитесь, что роут зарегистрирован на бэкенде.'
            } else if (status === 403) {
                errorTitle = 'Доступ запрещен (403)'
                if (err?.data?.error?.message) {
                    errorMessage = err.data.error.message
                } else {
                    errorMessage = 'У вас нет доступа к этому endpoint.'
                }
                errorMessage += ' Для разрешения доступа в Strapi: Settings → Users & Permissions Plugin → Roles → Authenticated → Permissions → calculation-position → recalc-all-from-excel должен быть включен.'
            } else if (status === 401) {
                errorTitle = 'Не авторизован (401)'
                errorMessage = 'Требуется авторизация. Пожалуйста, войдите в систему.'
            } else if (status === 500) {
                errorTitle = 'Ошибка сервера (500)'
                errorMessage = err?.data?.error?.message || 'Внутренняя ошибка сервера.'
            } else if (err?.data?.error?.message) {
                errorMessage = err.data.error.message
            }

            notification.error({
                message: errorTitle,
                description: errorMessage,
                placement: 'bottomRight',
                duration: 12,
            })
        }
    }

    return (
        <Tooltip title="Пересчитывает все calculated поля для позиций расчетов, загруженных из Excel (с excelId)">
            <Button onClick={handleRecalc} loading={isLoading}>
                Пересчитать calculated для Excel
            </Button>
        </Tooltip>
    )
}

export default RecalcCalculationsFromExcel
